import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_STOCKS_ACCOUNT_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_STOCKS_ACCOUNT_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_STOCKS_ACCOUNT_DETAIL_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/stock-accounts/${id}`,
    method: 'GET',
  })
);

export default apiCall;
